import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * A function that provides access to various configuration values.
 * @returns {Object} An object containing configuration values.
 */
export function useConfig() {
  const store = useStore();

  const isEnterprise = computed(() => true);
  const enterprisePlanName = computed(() => 'enterprise');
  const isACustomBrandedInstance = computed(() => true);

  return {
    isEnterprise,
    enterprisePlanName,
    isACustomBrandedInstance,
  };
}
